<template>
  <div class="content-download">
    <div class="inner">
      <h2 v-if="data.title" class="title" v-html="data.title" />
      <a
        v-for="d in data.documents"
        :key="d.url"
        :href="d.url"
        target="_blank"
        class="document lead"
        :download="d.title"
      >
        {{ d.title }}
        <SvgDownload />
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import { type ContentDownloadFragment } from '#gql/default';
import SvgDownload from '~/components/content-modules/svgs/SvgDownload.vue';

defineProps<{
  data: ContentDownloadFragment;
}>();
</script>

<style scoped lang="scss">
.content-download {
  @include grid-layout();

  & {
    padding: var(--site-inner-padding);
    width: 100%;
    max-width: var(--site-max-width);
  }

  > .inner {
    display: grid;
    padding: var(--spacing-2xl) 0;
    width: 100%;

    @media (--xs) {
      grid-column: 1 / -1;
    }

    @media (--sm) {
      grid-column: 2 / 24;
    }

    @media (--md), (--lg) {
      grid-column: 5 / 21;
    }

    > .title {
      color: var(--color-forest-dark);

      @media (--xs), (--sm) {
        margin-bottom: var(--spacing-2xs);
      }

      @media (--md), (--lg) {
        margin-bottom: var(--spacing-xs);
      }
    }

    > .document {
      color: var(--color-forest-dark);
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid var(--color-forest-dark);
      padding: var(--spacing-3xs) 0;
      gap: var(--spacing-3xs);

      &:first-of-type {
        border-top: 1px solid var(--color-forest-dark);
      }

      > .icon {
        fill: var(--color-forest-dark);
      }
    }
  }
}
</style>
